import "./OurProgram.module.css";
import Navigation from "@/reusable_sections/Header";
import Curriculum from "./sections/Curriculum";
import Day from "./sections/Day";
import Nourishing from "./sections/Nourishing";
import Footer from "@/reusable_sections/Footer";
export default function OurProgramPage() {
  return <div>
      <Navigation />
      <Curriculum />
      <Day />
      <Nourishing />
      <Footer />
    </div>;
}